import { useState, useRef, ChangeEvent, FC } from "react";
import { Eye, EyeOff } from "lucide-react";

// Interface pour les props du composant
interface PasswordInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const PasswordInput: FC<PasswordInputProps> = ({
  value,
  onChange,
  placeholder = "Entrez votre mot de passe",
}) => {
  const [showPass, setShowPass] = useState(false);

  // Fonction de gestion du changement
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div
      style={{
        position: "relative",
        marginBottom: "20px",
        border: "1px solid #000000",
        boxSizing: "border-box",
        borderRadius: "0px",
        display: "flex",
        alignItems: "center",
        width: "100%",
        // Ces propriétés empêchent que le div perde son apparence
        padding: "0",
        background: "white",
      }}
    >
      <input
        type={showPass ? "text" : "password"}
        style={{
          fontFamily: "Montserrat, sans-serif",
          fontSize: "15px",
          lineHeight: "18.53px",
          fontWeight: "400",
          width: "100%",
          padding: "10px",
          margin: "0",
          border: "none",
          color: "black",
          outline: "none",
          boxSizing: "border-box",
          background: "transparent",
        }}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        required
      />
      <div
        onClick={() => setShowPass(!showPass)}
        style={{
          cursor: "pointer",
          padding: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "30px",
          height: "30px",
          marginRight: "5px",
        }}
      >
        {showPass ? (
          <EyeOff size={20} color="#333" />
        ) : (
          <Eye size={20} color="#333" />
        )}
      </div>
    </div>
  );
};

export default PasswordInput;
